import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { DELETE_ATTRIBUTE, FETCH_ATTRIBUTE, FETCH_ATTRIBUTES } from './actionTypes'
import { getAttributesInOrder, makeGetAttributeById } from './selectors'

export const fetchAttributes = (): AppThunk => {
  return (dispatch, getState) => {
    return dispatch(
      request(
        '/organizations/:organizationId/usersattributes',
        FETCH_ATTRIBUTES,
        {},
        { cached: getAttributesInOrder(getState()).length > 0, ignoreLatest: true }
      )
    )
  }
}

export const fetchAttribute = (attributeId: string): AppThunk => {
  const getAttribute = makeGetAttributeById()

  return (dispatch, getState) => {
    return dispatch(
      request(
        `/organizations/:organizationId/usersattributes/${attributeId}`,
        FETCH_ATTRIBUTE,
        {},
        { cached: !!getAttribute(getState(), attributeId) }
      )
    )
  }
}

export const deleteAttribute = (attributeId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/usersattributes/${attributeId}`,
        DELETE_ATTRIBUTE,
        { method: 'DELETE' },
        { args: { attributeId } }
      )
    )
  }
}
